function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React, { memo, useMemo, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import ResizeObserver from 'resize-observer-polyfill';
import { useMainContext } from "../main-context";
import { cookieCss } from "./styles";
import { SHOWN_COOKIE_AREA_CLASSNAME, SHOWN_COOKIE_AREA_SELECTOR, ONETRUST_SDK_SELECTOR, ONETRUST_BANNER_CLOSED_COOKIE_NAME, COOKIE_ACCEPT_INTENT_KEY, ONE_TRUST_COOKIES_REJECTED_EVENT, ONE_TRUST_MODAL_REJECT_ALL_BUTTON_SELECTOR } from "./constants";
import lastOnetrustUpdate from "./last-onetrust-update";
import { useCookiBannerHeightSetter } from "./cookie-safe-area-provider";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var allTranslations = {
  en: function en(_ref) {
    var TYPEFORM_ROOT_DOMAIN = _ref.TYPEFORM_ROOT_DOMAIN;
    return {
      title: 'Cookie consent',
      text: "We use our own and third-party cookies to show you more relevant content based on your browsing and navigation history. Please accept or manage your cookie settings below. Here's our",
      linkHref: "https://admin.".concat(TYPEFORM_ROOT_DOMAIN, "/to/dwk6gt/"),
      linkTitle: 'cookie policy',
      settingsLabel: 'Cookie settings',
      acceptLabel: 'Accept all cookies'
    };
  },
  es: function es(_ref2) {
    var TYPEFORM_ROOT_DOMAIN = _ref2.TYPEFORM_ROOT_DOMAIN;
    return {
      title: 'Cookies',
      text: 'Usamos cookies propias y de terceros para mostrarte contenidos más relevantes con base en tu historial de navegación. Puedes acceptar o gestionar la configuración sobre cookies más abajo. También puedes consultar nuestra',
      linkHref: "https://admin.".concat(TYPEFORM_ROOT_DOMAIN, "/to/yFvrNI/"),
      linkTitle: 'política de cookies',
      settingsLabel: 'Configuración de cookies',
      acceptLabel: 'Aceptar todas las cookies'
    };
  }
};
export var consentScriptContent = "\nvar shouldShowBanner = false;\nif(document.cookie.indexOf('".concat(ONETRUST_BANNER_CLOSED_COOKIE_NAME, "') === -1){\n  shouldShowBanner = true;\n} else {\n  var cookieString = document.cookie;\n  var i = document.cookie.indexOf('").concat(ONETRUST_BANNER_CLOSED_COOKIE_NAME, "') + ('").concat(ONETRUST_BANNER_CLOSED_COOKIE_NAME, "=').length;\n  var dateString = '';\n\n  while(cookieString[i] && cookieString[i] !== ';') {\n    dateString += cookieString[i];\n    i++;\n  }\n\n  // check if reconsent needed because of onetrust list update\n  if(new Date('").concat(lastOnetrustUpdate, "') > new Date(dateString)) {\n    shouldShowBanner = true;\n  }\n}\n\n// user accepted cookie but left the page before onetrust was called\ntry {\n  if(localStorage.getItem('").concat(COOKIE_ACCEPT_INTENT_KEY, "')) {\n    shouldShowBanner = false;\n  }\n} catch (err) {\n  console.warn('Localstorage was not accessible');\n}\n\n\nif(shouldShowBanner) {\n  document.documentElement.classList.add('").concat(SHOWN_COOKIE_AREA_CLASSNAME, "');\n}\n");
export var ConsentScript = function ConsentScript() {
  return /*#__PURE__*/_jsx("script", {
    dangerouslySetInnerHTML: {
      __html: consentScriptContent
    }
  });
};
export var createCookieBannerScript = function createCookieBannerScript(locale) {
  return "\n  var settingsClicked = false;\n  var isFirstCallbackCall = true;\n  var oneTrustCookiesRejectedEvent = new Event('".concat(ONE_TRUST_COOKIES_REJECTED_EVENT, "');\n\n  var callSdk = function(callback) {\n    if (!document.querySelector('").concat(ONETRUST_SDK_SELECTOR, "')) {\n      setTimeout(function() {\n        callSdk(callback)\n      }, 100)\n    } else {\n      callback()\n    }\n  }\n\n  function hideBanner() {\n    var shownBanner = document.querySelector('").concat(SHOWN_COOKIE_AREA_SELECTOR, "');\n\n    if(shownBanner) {\n      shownBanner.classList.remove('").concat(SHOWN_COOKIE_AREA_CLASSNAME, "')\n    }\n  }\n\n  function onRejectAllCookies() {\n    window.dispatchEvent(oneTrustCookiesRejectedEvent)\n  }\n\n  function onShowSettings() {\n    settingsClicked = true;\n\n    callSdk(function sdkSettingsCallback() {\n      window.OneTrust.ToggleInfoDisplay()\n\n      var rejectAllButton = document.querySelector('").concat(ONE_TRUST_MODAL_REJECT_ALL_BUTTON_SELECTOR, "');\n\n      if (rejectAllButton) {\n        rejectAllButton.addEventListener('click', onRejectAllCookies)\n      }\n\n      settingsClicked = false;\n    })\n  }\n\n  function onAllowAllCookies() {\n    try {\n      localStorage.setItem('").concat(COOKIE_ACCEPT_INTENT_KEY, "', true)\n    } catch(err) {\n      console.warn('Localstorage is not accessible');\n    }\n\n    hideBanner();\n\n    callSdk(function sdkAllowCallback() {\n      window.OneTrust.AllowAll();\n      window.OneTrust.TriggerGoogleAnalyticsEvent('Inhouse Cookie Consent', 'Banner Accept Cookies');\n\n      try {\n        localStorage.removeItem('").concat(COOKIE_ACCEPT_INTENT_KEY, "')\n      } catch(err) {\n        console.warn('Localstorage is not accessible');\n      }\n    });\n  }\n\n  window.OptanonWrapper = function OptanonWrapper() {\n    if (isFirstCallbackCall) {\n      isFirstCallbackCall = false;\n      return;\n    }\n\n    if (!settingsClicked) {\n      hideBanner();\n    }\n  }\n\n  function attachCookieConsentListeners() {\n    document.querySelector('.cookie-settings-link').addEventListener('click', onShowSettings);\n    document.querySelector('.cookie-accept-btn').addEventListener('click', onAllowAllCookies);\n  }\n\n  try {\n    if(localStorage.getItem('").concat(COOKIE_ACCEPT_INTENT_KEY, "')) {\n      onAllowAllCookies();\n    }\n  } catch(err) {\n    console.warn('Localstorage is not accessible');\n  }\n\n  callSdk(function setLanguage() {\n    window?.OneTrust?.changeLanguage?.('").concat(locale, "')\n  })\n  attachCookieConsentListeners();\n");
};
var CookieBanner = function CookieBanner(_ref3) {
  var locale = _ref3.locale,
    onCookiesRejected = _ref3.onCookiesRejected;
  var _allTranslations$loca;
  var _useMainContext = useMainContext(),
    sharedVariables = _useMainContext.sharedVariables;
  var translations = ((_allTranslations$loca = allTranslations[locale]) === null || _allTranslations$loca === void 0 ? void 0 : _allTranslations$loca.call(allTranslations, sharedVariables)) || allTranslations['en'](sharedVariables);
  var bannerBoundariesRef = useRef();
  var setCookieBannerHeight = useCookiBannerHeightSetter();
  useEffect(function () {
    var _window$attachCookieC, _window;
    if (typeof window === 'undefined' || !setCookieBannerHeight) {
      return;
    }
    (_window$attachCookieC = (_window = window).attachCookieConsentListeners) === null || _window$attachCookieC === void 0 ? void 0 : _window$attachCookieC.call(_window);
    var bannerBoundariesElement = bannerBoundariesRef.current;
    if (!bannerBoundariesElement) {
      return;
    }
    var lastBannerSize = 0;
    var resizeObserver = new ResizeObserver(function (entries) {
      var isEntriesIterable = (Symbol.iterator in Object(entries));
      if (!isEntriesIterable) {
        return;
      }
      var newBannerSize;
      var _iterator = _createForOfIteratorHelper(entries),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          var _entry$borderBoxSize;
          newBannerSize = ((_entry$borderBoxSize = entry.borderBoxSize) === null || _entry$borderBoxSize === void 0 ? void 0 : _entry$borderBoxSize.length) > 0 ? entry.borderBoxSize[0].blockSize : entry.contentRect.height;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (newBannerSize === lastBannerSize) {
        return;
      }
      setCookieBannerHeight(newBannerSize);
      lastBannerSize = newBannerSize;
    });
    resizeObserver.observe(bannerBoundariesElement);
    return function () {
      resizeObserver.unobserve(bannerBoundariesElement);
    };
  }, [setCookieBannerHeight]);
  useEffect(function () {
    var handleCookiesRejected = function handleCookiesRejected() {
      onCookiesRejected === null || onCookiesRejected === void 0 ? void 0 : onCookiesRejected();
    };
    window.addEventListener(ONE_TRUST_COOKIES_REJECTED_EVENT, handleCookiesRejected);
    return function () {
      window.removeEventListener(ONE_TRUST_COOKIES_REJECTED_EVENT, handleCookiesRejected);
    };
  }, [onCookiesRejected]);
  var cookieBannerScript = useMemo(function () {
    return createCookieBannerScript(locale);
  }, [locale]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("style", {
      children: cookieCss
    }), /*#__PURE__*/_jsx("div", {
      className: "cookie-consent-area",
      children: /*#__PURE__*/_jsxs("div", {
        className: "cookie-consent-banner",
        role: "alertdialog",
        "aria-label": translations.title,
        "aria-describedby": "cookie-consent",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "cookie-consent-banner-content",
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("h3", {
              id: "cookie-consent-title",
              children: translations.title
            }), /*#__PURE__*/_jsxs("p", {
              className: "cookie-consent-text",
              children: [translations.text, "\xA0", /*#__PURE__*/_jsx("a", {
                href: translations.linkHref,
                target: "_blank",
                rel: "noopener noreferrer",
                children: translations.linkTitle
              })]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "cookie-buttons",
            children: [/*#__PURE__*/_jsx("button", {
              className: "cookie-accept-btn",
              children: translations.acceptLabel
            }), /*#__PURE__*/_jsx("button", {
              className: "cookie-settings-link",
              children: translations.settingsLabel
            })]
          })]
        }), /*#__PURE__*/_jsx("div", {
          "data-testid": "cookie-consent-banner-boundaries",
          className: "cookie-consent-banner-boundaries",
          ref: bannerBoundariesRef
        })]
      })
    }), /*#__PURE__*/_jsx("script", {
      dangerouslySetInnerHTML: {
        __html: cookieBannerScript
      }
    }, 'cookieBannerScript')]
  });
};
CookieBanner.propTypes = {
  locale: PropTypes.string,
  onCookiesRejected: PropTypes.func
};
CookieBanner.defaultProps = {
  locale: 'en',
  onCookiesRejected: undefined
};
export default /*#__PURE__*/memo(CookieBanner);